import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommHeartFillIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M3.96233 3.13335C7.01273 1.25797 9.74925 2.00539 11.4024 3.24971C11.6744 3.45442 11.861 3.59452 12 3.68913C12.139 3.59452 12.3256 3.45442 12.5976 3.24971C14.2507 2.00539 16.9873 1.25797 20.0377 3.13335C22.1469 4.43012 23.3338 7.13887 22.9173 10.2511C22.4988 13.3784 20.4793 16.9154 16.2023 20.0883C16.1665 20.1148 16.1311 20.1412 16.0959 20.1673C14.6107 21.2698 13.6271 21.9999 12 21.9999C10.3729 21.9999 9.38932 21.2698 7.90413 20.1673C7.86894 20.1412 7.83346 20.1148 7.79768 20.0883C3.52072 16.9154 1.50116 13.3784 1.08269 10.2511C0.666226 7.13887 1.85307 4.43012 3.96233 3.13335ZM11.8396 3.78825C11.8363 3.78974 11.8369 3.78925 11.841 3.78759L11.8396 3.78825ZM12.159 3.78759C12.1631 3.78925 12.1637 3.78974 12.1604 3.78825L12.159 3.78759Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
